var React = require('react');

function Tractor48px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M46.264 32.16a.998.998 0 0 1-.984.839h-2.537a6.983 6.983 0 0 1 2.11 5c0 3.86-3.131 7-6.979 7-3.847 0-6.976-3.14-6.976-7 0-1.959.811-3.728 2.109-5h-7.23c.015.119.041.233.053.353.057.58.084 1.117.084 1.647 0 .552-.446 1-.997 1a.998.998 0 0 1-.997-1c0-.464-.024-.938-.074-1.447A13.942 13.942 0 0 0 9.945 20.999a13.83 13.83 0 0 0-8.354 2.783.994.994 0 0 1-1.394-.203 1.002 1.002 0 0 1 .201-1.4 15.834 15.834 0 0 1 5.482-2.65V.999c0-.553.544-1 1.095-1h15.949c.401 0 .763.242.919.612l7.811 18.612 5.224.72v-4.768c0-2.303 1.789-4.176 3.987-4.176.551 0 .997.448.997 1.001a.998.998 0 0 1-.997.999c-1.099 0-1.993.976-1.993 2.176v5.043l8.109 1.118a1 1 0 0 1 .849 1.151l-1.566 9.673zm-13.373 5.839c0 2.757 2.235 5 4.983 5 2.749 0 4.985-2.243 4.985-5 0-2.756-2.236-5-4.985-5-2.748 0-4.983 2.244-4.983 5zm-10.629-36H7.88v17h21.517l-7.135-17zm7.639 19h-12.21a15.942 15.942 0 0 1 7.704 10h19.037l1.266-7.82-15.797-2.18zm-19.935 4c5.496 0 9.967 4.486 9.967 10 0 5.515-4.471 10-9.967 10s-9.968-4.485-9.968-10c0-5.514 4.472-10 9.968-10zm0 18c4.396 0 7.974-3.589 7.974-8 0-4.41-3.578-8-7.974-8-4.397 0-7.974 3.59-7.974 8 0 4.411 3.577 8 7.974 8z","key":1})]);
}

Tractor48px.displayName = "Tractor48px";

Tractor48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 47.82 45"};

module.exports = Tractor48px;

Tractor48px.default = Tractor48px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/tractor-48px.svg
// module id = 1170
// module chunks = 0